import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";

async function getMasterApiTokenRequest(): Promise<string> {
  return (await get(`customers/master-key`)).master_api_key;
}
export default function useMasterApiToken() {
  const { isLoading: isLoadingMasterApiToken, data: masterApiToken } = useQuery(
    {
      queryKey: ["masterApiKey"],
      queryFn: () => getMasterApiTokenRequest(),
    },
  );

  return {
    masterApiToken,
    isLoadingMasterApiToken,
  };
}
